import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import {
  CharacterSetting,
  CharacterSettingListParams,
  CreateCharacterSettingPayload,
  UpdateCharacterSettingPayload,
} from './models/characterSetting';

const characterSettingService = {
  getList(params?: CharacterSettingListParams): Promise<CommonResponse<CharacterSetting[]>> {
    return axiosClient.get('/character-settings', { params });
  },
  getItem(id: number): Promise<CommonResponse<CharacterSetting>> {
    return axiosClient.get(`/character-setting/${id}`);
  },
  create(payload: CreateCharacterSettingPayload): Promise<CommonResponse<CharacterSetting>> {
    return axiosClient.post('/character-settings', payload);
  },
  updateMany(payload: UpdateCharacterSettingPayload[]): Promise<CommonResponse<CharacterSetting[]>> {
    return axiosClient.patch('/character-settings', payload);
  },
  update(id: number, payload: UpdateCharacterSettingPayload): Promise<CommonResponse<CharacterSetting>> {
    return axiosClient.put(`/character-setting/${id}`, payload);
  },
  delete(ids: number[]): Promise<CommonResponse<{ deleted_ids: number[] }>> {
    if (ids.length === 1) {
      return axiosClient.delete(`/character-setting/${ids[0]}`);
    }
    return axiosClient.patch(
      '/character-settings',
      ids.map((id) => ({ id, delete_flg: true }))
    );
  },
  setStatus(id: number): Promise<CommonResponse<CharacterSetting>> {
    return axiosClient.post(`/character-setting/${id}/set-status`);
  },
};

export default characterSettingService;
